/* eslint-disable */
export default {
  conferenceCall: 'Conference call',
  onHold: 'In de wacht',
  ongoing: 'Lopend',
  unknown: 'Onbekend',
  disconnected: 'Verbinding verbroken',
  loading: 'Laden...',
  loadingTimeout: 'Time-out bij het laden.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
